module.exports = __webpack_public_path__ + "img/ele-out-75.c19317cd.png";